import { ALERT } from '../actions/alert'

export default (state = false, action = {}) => {
  switch (action.type) {
    case ALERT:
      return !state
      default:
          return state
  }
}